import React from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import success from '../../Assets/success.png';
import './PaymentSuccess.css';
import Seo from '../../Components/Seo/Seo';
import { useSiteSeo } from '../../context/SiteSeoContext';
import { usePrerenderReady } from '../../utils/prerenderReady';

export default function PaymentSuccess() {
  const location = useLocation();
  const { orderId, total } = location.state || {};
  const siteCtx = useSiteSeo();
  const titleSuffix =
    siteCtx.organization_name && String(siteCtx.organization_name).trim()
      ? ` | ${String(siteCtx.organization_name).trim()}`
      : ' | Gem Fashion Studios';
  usePrerenderReady(true);

  // Guard after all hooks: direct visits with no order context redirect to account
  if (!orderId) {
    return <Navigate to="/account/orders" replace />;
  }

  const formatDate = (d) => {
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <Seo
        title={`Order received${titleSuffix}`}
        description="Thank you for your rental order. Confirmation details are shown on this page."
        canonicalPath="/payment/success"
        noindex
      />
      <div className="payment-success-page">
        <div className="payment-success-card">
          <div className="payment-success-icon">
            <img src={success} alt="" />
          </div>
          <h2>Your order is completed!</h2>
          <p>Thank you. Your order has been received.</p>
          <div className="payment-success-details">
            <div className="payment-success-item">
              <p>Order Number</p>
              <h4>{orderId ?? '—'}</h4>
            </div>
            <div className="payment-success-item">
              <p>Date</p>
              <h4>{formatDate(new Date())}</h4>
            </div>
            <div className="payment-success-item">
              <p>Total</p>
              <h4>₹{(total ?? 0).toFixed(2)}</h4>
            </div>
          </div>
          <Link to="/account/orders" className="payment-success-link">View orders</Link>
          <Link to="/shop" className="payment-success-link secondary">Continue shopping</Link>
        </div>
      </div>
    </>
  );
}
